import { Check } from "lucide-react";

const steps = ["Customer", "Measurements", "Items", "Checkout", "Confirm"];

export default function StepIndicator({ currentStep }) {
  return (
    <div className="flex items-center justify-center gap-0 mb-10" data-testid="step-indicator">
      {steps.map((label, i) => {
        const isCompleted = i < currentStep;
        const isActive = i === currentStep;
        return (
          <div key={label} className="flex items-center">
            <div className="flex flex-col items-center">
              <div
                data-testid={`step-${i}`}
                className={`w-8 h-8 flex items-center justify-center border-2 transition-all duration-300 ${
                  isCompleted
                    ? "bg-[#9F7D23] border-[#9F7D23] text-white"
                    : isActive
                    ? "border-[#9F7D23] text-[#9F7D23] bg-white"
                    : "border-[#D6D6CF] text-[#D6D6CF] bg-white"
                }`}
              >
                {isCompleted ? <Check className="w-4 h-4" /> : <span className="font-['Space_Mono'] text-xs">{i + 1}</span>}
              </div>
              <span
                className={`font-['Space_Mono'] text-[10px] tracking-widest uppercase mt-2 ${
                  isActive ? "text-[#9F7D23]" : isCompleted ? "text-[#5C4D24]" : "text-[#D6D6CF]"
                }`}
              >
                {label}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div
                className={`w-8 md:w-16 h-[2px] mx-1 mt-[-16px] transition-colors ${
                  i < currentStep ? "bg-[#9F7D23]" : "bg-[#D6D6CF]"
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
